<template>
  <section class="section contact-form">
    <h2>Contact Us</h2>
    <form id="contact-form">
      <div class="contact-form__row">
        <div class="input">
          <label for="contact-form-name">Name*</label>
          <input id="contact-form-name" v-model="name" type="text">
        </div>
        <div class="input">
          <label for="contact-form-email">E-mail*</label>
          <input id="contact-form-email" v-model="email" type="email">
        </div>
      </div>
      <div class="contact-form__row">
        <div class="input">
          <label for="contact-form-message">Message*</label>
          <textarea id="contact-form-message" v-model="message" type="text" rows="10"></textarea>
        </div>
      </div>
      <a :href="'mailto:raab@pv-pa.com?subject='+ name +' would like to contact you&body=E-mail: '+ email +'<br><br>' + message" class="button button--primary">Send</a>
    </form>
  </section>
</template>

<script>
export default {
  name: 'contact-form',
  data() {
    return {
      name: '',
      email: '',
      message: '',
    };
  },
};
</script>
